import { render, staticRenderFns } from "./SuggestFlexPropsSchema.vue?vue&type=template&id=56379eb7&"
import script from "./SuggestFlexPropsSchema.vue?vue&type=script&lang=js&"
export * from "./SuggestFlexPropsSchema.vue?vue&type=script&lang=js&"
import style0 from "./SuggestFlexPropsSchema.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports